import VueDatePicker from 'vuejs-datepicker'
import VueConfetti from 'vue-confetti'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { Money } from 'v-money'

import AlertComponent from './Alert.vue'
import CheckoutButton from './CheckoutButton.vue'
import FooterLogo from './FooterLogo.vue'
import FooterDefault from './FooterDefault.vue'
import IdleComponent from './Idle.vue'
import NoteComponent from './Note.vue'
import PolicyComponent from './Policy.vue'
import PopoverComponent from './Popover.vue'
import ProgressComponent from './Progress.vue'
import RolesList from './RolesList.vue'
import SpinnerComponent from './Spinner.vue'
import StepperComponent from './Stepper.vue'
import SwitchComponent from './Switch.vue'
import TourComponent from './Tour.vue'
import TrainingList from './TrainingList.vue'

export default {
    install(Vue) {
        Vue.use(VueConfetti);
        Vue.component('vue-datepicker', VueDatePicker);
        Vue.component('vue-slider', VueSlider);
        Vue.component('vue-money', Money);
        Vue.component('hm-alert', AlertComponent);
        Vue.component('hm-checkout', CheckoutButton);
        Vue.component('hm-footer', FooterDefault);
        Vue.component('hm-footer-logo', FooterLogo);
        Vue.component('hm-idle-dlg', IdleComponent);
        Vue.component('hm-note', NoteComponent);
        Vue.component('hm-policy', PolicyComponent);
        Vue.component('hm-popover', PopoverComponent);
        Vue.component('hm-progress', ProgressComponent);
        Vue.component('hm-roleslist', RolesList);
        Vue.component('hm-spinner', SpinnerComponent);
        Vue.component('hm-stepper', StepperComponent);
        Vue.component('hm-switch', SwitchComponent);
        Vue.component('hm-tour', TourComponent);
        Vue.component('hm-traininglist', TrainingList);
    }
}